import { ActionType, useActionState } from '../../../status/state/actions.state';

import { BulkEditPill } from './BulkEditPill';
import styled from '@emotion/styled';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useParentItemsFromBulkEditSelection } from './bulk-edit.state';
import { useParentItemsFromSelectedSubItems } from '../../state/selection.state';

export const BulkEditActionSheetPillBar = () => {
   const actionType = useActionState((state) => state.actionType);

   const mainTableItemSelection = useParentItemsFromSelectedSubItems(
      actionType === ActionType.bulkAdding
   );
   const bulkEditTableItemSelection = useParentItemsFromBulkEditSelection();

   const items = actionType === ActionType.bulkEditing ? bulkEditTableItemSelection : mainTableItemSelection;

   return (
      <StyledWrapperDiv>
         {items.map((item) => (
            <BulkEditPill item={item} lastItem={items.length === 1} disableClose={true} key={item.id} />
         ))}
      </StyledWrapperDiv>
   );
};

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  justify-content: center;
  padding-bottom: ${tokens.space.lg};
`;
